module.exports = "https://static.zego.com/_next/static/images/EsAdnDelSeguro-57ae8f5d257f2df9113ec1024875d7d0.png";